import React, { useState, useEffect } from "react";
import ClosingCosts from "./ClosingCosts";
import DummyClosingCosts from "./DummyClosingCosts";
import ContactUs from "./ContactUs";
import Content from "../../../Content";
import Emailer from "../../../Emailer";
import OtherDetails from "../OtherDetails/OtherDetails";
import styled from "styled-components";
import Disclaimer from "./Disclaimer";
import MobileFooter from "./MobileFooter";
import Title from '../../basics/Title';
import useLanguage from "../../../../utilities/useLanguage";
import { getTranslation } from "../../translations";

const CostsContainer = styled.div`
    @media(max-width:987px){
        h3, h4{
            text-align:center;
        }
    }

    @media(min-width:769px) and (max-width:990px){
        .amount{
            font-size:29px;
        }

        .per-month{
            line-height: .7rem;
            font-size: 10px;
            margin-left: 5px;
        }
    }

`;

export default (props) => {
    const { lang } = useLanguage();

    const [rate, setRate] = useState({
        monthlyPayment: 0,
        isSet: false,
        rate:
        {
            initialRate: 0,
            disclosureInformation: { apr: 0 }
        }
    });

    useEffect(() => {
        if (props.show && props.details) {
            setRate({
                monthlyPayment: props.details.monthlyPayment,
                isSet: true,
                rate:
                {
                    initialRate: props.details.Rate,
                    disclosureInformation: { apr: props.details.Apr }
                }
            });
        }
    }, [props.show, props.details]);
    return (
        <CostsContainer>
            <Title className="mb-2">{getTranslation(lang).paymentClosingCosts}</Title>
            <Content className="pb-5">
                <DummyClosingCosts {...props} />
                <ClosingCosts {...props} rate={rate} />
                <ContactUs show={props.show} details={props.details} />
                <div className="row">
                    <div className="col-12 col-md-6">
                        {props.showEmailForm && <Emailer emailValues={props.emailValues}
                            sendEmail={props.sendEmail}
                            className="text-dark"
                            header= "Send me this loan info"
                            label="Get these loan details in your inbox"
                            inputClassName="col-lg-6"
                            emailInputClassName="col-lg-8"
                            emailSentSubText="Your actual rate, payment, and costs could be higher. Get an official Loan Estimate before choosing a loan."
                            show={props.show}
                            emailSent={props.emailSent}
                            onChange={props.onEmailFormChange} />}
                    </div>
                    {props.details && <OtherDetails header={props.otherDetailsHeader} label={props.otherDetailsLabel} />}
                </div>
                <Disclaimer disclaimer={props.disclaimer} className="d-lg-none p-4" />
            </Content>
            <Disclaimer disclaimer={props.disclaimer} className="d-none d-lg-block pb-4" />
            <div className="mrqt-row">
                <MobileFooter show={props.show} rate={rate} applyNowUrl={props.employee.applyNowUrl} />
            </div>
        </CostsContainer>
    );
};
